<template>
  <v-card>
    <v-toolbar color="secondary" class="elevation-0">
      <v-toolbar-title> Plans </v-toolbar-title>
    </v-toolbar>
    <v-card-actions v-if="!tenant_uid">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        outlined
        dense
        hide-details
      ></v-text-field>
    </v-card-actions>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="items"
        disable-sort
        disable-pagination
        dense
        hide-default-footer
        :search="search"
        @click:row="openDetail"
      >
        <template v-slot:[`item.active`]="{ item }">
          <v-icon v-if="item.active"> mdi-check </v-icon>
          <v-icon v-if="!item.active"> mdi-close </v-icon>
        </template>
        <template v-slot:[`item.visible`]="{ item }">
          <v-icon v-if="item.visible"> mdi-check </v-icon>
          <v-icon v-if="!item.visible"> mdi-close </v-icon>
        </template>
        <template v-slot:[`item.details`]="{ item }">
          <v-btn icon @click.stop="showDetails(item)">
            <v-icon>mdi-clipboard-outline</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>

    <v-dialog v-model="detailsDialog" width="500">
      <v-card>
        <v-toolbar color="secondary" class="elevation-0">
          <v-toolbar-title>
            {{ this.item?.name }} - {{ this.item?.code }}
          </v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="detailsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-5 px-5">
          <pre class="text-body-1">{{
            JSON.stringify(this.item?.details, null, 2)
          }}</pre>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["tenant_uid"],
  data: () => ({
    loading: false,
    detailsDialog: false,
    item: null,
    search: null,
    headers: [
      { text: "Name", value: "name" },
      { text: "Plan Code", value: "code" },
      { text: "Active", value: "active" },
      { text: "Visible", value: "visible" },
      { text: "Details", value: "details" },
    ],
  }),

  watch: {
    detailDialog(val) {
      if (!val) this.item = null;
    },
  },

  computed: {
    ...mapGetters(["plans", "subscriptions"]),
    items() {
      let plans = this.plans
      if (this.tenant_uid) plans = plans?.filter(p => this.codesFromTenant.includes(p.code) )
      return plans?.map((p) => ({
        name: p.name,
        code: p.code,
        active: p.is_active,
        visible: p.visible,
        details: p,
      }));
    },
    codesFromTenant() {
      return this.subscriptions
        ?.filter((s) => !this.tenant_uid || s.tenant_uid === this.tenant_uid)
        .map(s => s.plan_code)
    }
  },

  methods: {
    showDetails(item) {
      this.item = item;
      this.detailsDialog = true;
    },
    openDetail(item) {
      this.$router.push("/plans/" + item.details.code);
    },
  },
};
</script>
